
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UIButton from "@/components/button/ui-button.vue";
  import Card from "@/components/card/Card.vue";
  import TableAvatar from "@/components/table/TableAvatar.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";

  import RouteParams from "@/entities/RouteParams";
  import RouteNames from "@/entities/RouteNames";

  @Component({
    components: {
      UIButton,
      Card,
      TableAvatar,
      CardBodyItem,
    },
  })
  export default class BasicEmployeeCard extends Vue {
    @Prop({ type: String, required: true }) readonly managerId!: string;
    @Prop({ type: String, required: true }) readonly firstName!: string;
    @Prop({ type: String, required: true }) readonly lastName!: string;
    @Prop({ type: String, default: undefined }) readonly jobTitle?: string;
    @Prop({ type: String, default: undefined }) readonly location?: string;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;
    @Prop({ type: Boolean, default: true }) readonly allowActions!: boolean;


    get routeParams(): RouteParams<{ id: string }> {
      return {
        name: RouteNames.MANAGER_ABOUT,
        params: { id: this.managerId },
      };
    }

    get fullName(): string {
      return `${this.firstName} ${this.lastName}`;
    }

    get initials(): string {
      return `${this.firstName.trimStart()[0]}${this.lastName.trimStart()[0]}`;
    }

    get job(): string {
      if (!this.jobTitle) {
        return 'n/a';
      }
      return this.jobTitle;
    }

    get locationString(): string {
      if (!this.location) {
        return 'n/a';
      }
      return this.location;
    }
  }
